


// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { setUser } from '../Commonlibs/userSlice';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   IconButton,
//   InputAdornment,
//   TextField,
//   Typography,
//   useMediaQuery,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Loader from '../Loader/Loader';
// import leftImage from '../assets/logip.png';
// import houseLogo from '../assets/lob.png';
// import emailIcon from '../assets/email.png';
// import lockIcon from '../assets/lock.png';
// import phoneIcon from '../assets/phone.png';
// import tited from '../assets/tited.png';

// const Register = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     fullName: '',
//     email: '',
//     contactNumber: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [agreed, setAgreed] = useState(false);
  
//   // Success dialog state
//   const [successDialogOpen, setSuccessDialogOpen] = useState(false);

//   const validateField = (name, value) => {
//     if (!value.trim()) return '';
    
//     switch (name) {
//       case 'fullName':
//         return /^[a-zA-Z ]+$/.test(value) ? '' : 'Name is invalid';
//       case 'email':
//         return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
//           ? ''
//           : 'Email is invalid';
//       case 'contactNumber':
//         return /^\d{10}$/.test(value) ? '' : 'Phone number must be 10 digits';
//       default:
//         return '';
//     }
//   };

//   const handleFieldChange = (fieldName, value) => {
//     setFormData({ ...formData, [fieldName]: value });
//     const error = validateField(fieldName, value);
//     setErrors((prev) => ({ ...prev, [fieldName]: error }));
//   };

//   const validateOnSubmit = () => {
//     const newErrors = {};
//     let isValid = true;

//     Object.entries(formData).forEach(([key, value]) => {
//       if (!value.trim()) {
//         newErrors[key] =
//           key === 'contactNumber'
//             ? 'Phone number is required'
//             : `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
//         isValid = false;
//       } else {
//         const error = validateField(key, value);
//         newErrors[key] = error;
//         if (error) isValid = false;
//       }
//     });

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleNavigateToLogin = () => {
//     setSuccessDialogOpen(false);
//     navigate('/login');
//   };

//   const handleRegister = async () => {
//     if (!agreed) {
//       setErrors((prev) => ({ ...prev, agreed: 'Please agree to the Terms and Conditions.' }));
//       return;
//     }

//     if (!validateOnSubmit()) return;

//     setLoading(true);

//     const payload = {
//       full_name: formData.fullName,
//       email_id: formData.email,
//       contact_number: formData.contactNumber,
//       terms_conditions: agreed,
//     };

//     try {
//       const response = await fetch('https://propertydealstalk.com/api/users/userRegistration', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();

//       if (response.ok && data.status === "SUCCESS") {
//         setSuccessDialogOpen(true);
//       } else {
//         setErrors((prev) => ({ ...prev, submit: data.message || 'Registration failed. Please try again.' }));
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       setErrors((prev) => ({ ...prev, submit: 'Something went wrong. Please try again later.' }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       display="flex"
//       flexDirection={{ xs: 'column', md: 'row' }}
//       sx={{
//         width: '100%',
//         height: '100vh',
//         overflow: 'hidden'
//       }}
//     >
//       {/* Success Dialog */}
//       <Dialog
//         open={successDialogOpen}
//         onClose={() => setSuccessDialogOpen(false)}
//         aria-labelledby="success-dialog-title"
//         aria-describedby="success-dialog-description"
//         PaperProps={{
//           style: {
//             borderRadius: '8px',
//           }
//         }}
//       >
//         <DialogTitle id="success-dialog-title">
//           Registration Successful
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="success-dialog-description">
//             Your account has been created successfully!
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
//           <Button
//             onClick={handleNavigateToLogin}
//             color="primary"
//             variant="contained"
//             autoFocus
//             sx={{
//               bgcolor: '#0052ff',
//               borderRadius: 2,
//               textTransform: 'none',
//             }}
//           >
//             CLICK TO LOGIN
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Custom Loader */}
//       {loading && <Loader />}

//       {/* Left Image */}
//       <Box
//         width={isMobile ? '100%' : '40%'}
//         height={isMobile ? '30vh' : '100%'}
//         display="flex"
//         flexDirection="column"
//         justifyContent="center"
//         alignItems="center"
//         sx={{
//           backgroundColor: '#AA16FF1A',
//           padding: 4,
//           position: 'relative',
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             alignItems: 'center',
//             gap: 2,
//           }}
//         >
//           <img
//             src={tited}
//             alt="PropertyDealsTalk.com"
//             style={{
//               width: isMobile ? '280px' : '400px',
//               height: 'auto',
//               objectFit: 'contain'
//             }}
//           />
//         </Box>
//       </Box>

//       {/* Right Section */}
//       <Box
//         sx={{
//           width: { xs: '100%', md: '60%' },
//           height: { xs: 'calc(100vh - 30vh)', md: '100%' },
//           overflowY: { xs: 'auto', md: 'hidden' },
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           backgroundColor: '#fff',
//           px: { xs: 2, sm: 3 },
//           py: { xs: 2, sm: 3 },
//           boxSizing: 'border-box',
//         }}
//       >
//         {/* Logo and Heading */}
//         <Box
//           display="flex"
//           justifyContent="center"
//           sx={{ mt: 4, mb: 0.5 }}
//         >
//           <img src={houseLogo} alt="logo" style={{ width: 45, height: 45 }} />
//         </Box>
//         <Typography
//           variant="h6"
//           textAlign="center"
//           mb={1}
//           fontWeight={500}
//           fontSize="17px"
//         >
//           Create your account
//         </Typography>

//         {/* Form Box */}
//         <Box
//           sx={{
//             width: '100%',
//             maxWidth: 320,
//             borderRadius: 3,
//             p: { xs: 1.5, sm: 2 },
//             boxShadow: '0 0 20px rgba(0,0,0,0.05)',
//             border: '1px solid #eee',
//             mb: 2,
//             mx: 'auto',
//           }}
//         >
//           <Typography fontWeight={500} fontSize={14} mb={0.5}>
//             Fill the required details
//           </Typography>

//           <TextField
//             fullWidth
//             placeholder="Enter your full name*"
//             margin="dense"
//             value={formData.fullName}
//             onChange={(e) => handleFieldChange('fullName', e.target.value)}
//             error={Boolean(errors.fullName)}
//             helperText={errors.fullName}
//             sx={{
//               mb: 0.5,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{ style: { fontSize: 14 } }}
//           />

//           <TextField
//             fullWidth
//             placeholder="Phone Number*"
//             margin="dense"
//             value={formData.contactNumber}
//             onChange={(e) => {
//               // Only allow numeric input and limit to 10 digits
//               const newValue = e.target.value.replace(/\D/g, '').slice(0, 10);
//               handleFieldChange('contactNumber', newValue);
//             }}
//             error={Boolean(errors.contactNumber)}
//             helperText={errors.contactNumber}
//             sx={{
//               mb: 1,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{
//               style: { fontSize: 14 },
//               maxLength: 10
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <img src={phoneIcon} alt="phone" style={{ width: 18, marginRight: 10 }} />
//                   <Typography variant="body2" sx={{ fontSize: 14, color: 'text.secondary' }}>
//                     +91
//                   </Typography>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <TextField
//             fullWidth
//             placeholder="Enter your email*"
//             margin="dense"
//             value={formData.email}
//             onChange={(e) => handleFieldChange('email', e.target.value)}
//             error={Boolean(errors.email)}
//             helperText={errors.email}
//             sx={{
//               mb: 0.5,
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '12px',
//               },
//               '& .MuiFormHelperText-root': {
//                 fontSize: '11px',
//                 marginTop: 0
//               }
//             }}
//             inputProps={{ style: { fontSize: 14 } }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <img src={emailIcon} alt="email" style={{ width: 18, marginRight: 10 }} />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {errors.submit && (
//             <Typography color="error" fontSize={12} mb={1}>
//               {errors.submit}
//             </Typography>
//           )}

//           <FormControlLabel
//             control={
//               <Checkbox
//                 size="small"
//                 checked={agreed}
//                 onChange={(e) => setAgreed(e.target.checked)}
//               />
//             }
//             sx={{ mt: 0.5, mb: 0.5 }}
//             label={
//               <Typography sx={{ fontSize: 12 }}>
//                 I agree to the{' '}
//                 <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
//                   Terms of Service
//                 </Typography>{' '}
//                 and{' '}
//                 <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
//                   Privacy Policy
//                 </Typography>
//               </Typography>
//             }
//           />

//           {errors.agreed && (
//             <Typography color="error" fontSize={12} mb={1}>
//               {errors.agreed}
//             </Typography>
//           )}

//           <Button
//             variant="contained"
//             fullWidth
//             disabled={loading}
//             onClick={handleRegister}
//             sx={{
//               bgcolor: '#0052ff',
//               color: '#fff',
//               py: 1.2,
//               fontWeight: 500,
//               borderRadius: 2,
//               mt: 1,
//               fontSize: 14,
//               textTransform: 'none',
//             }}
//           >
//             Create Account
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Register;

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../Commonlibs/userSlice';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader/Loader';
import leftImage from '../assets/logip.png';
import emailIcon from '../assets/email.png';
import lockIcon from '../assets/lock.png';
import phoneIcon from '../assets/phone.png';
import tited from '../assets/tited.png';
import propmenu from '../assets/menugroup.png';
import home from '../assets/lob.png';

const Register = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
  });
  const [errors, setErrors] = useState({});
  const [agreed, setAgreed] = useState(false);
  
  // Success dialog state
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const validateField = (name, value) => {
    if (!value.trim()) return '';
    
    switch (name) {
      case 'fullName':
        return /^[a-zA-Z ]+$/.test(value) ? '' : 'Name is invalid';
      case 'email':
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
          ? ''
          : 'Email is invalid';
      case 'contactNumber':
        return /^\d{10}$/.test(value) ? '' : 'Phone number must be 10 digits';
      default:
        return '';
    }
  };

  const handleFieldChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
    const error = validateField(fieldName, value);
    setErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const validateOnSubmit = () => {
    const newErrors = {};
    let isValid = true;

    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] =
          key === 'contactNumber'
            ? 'Phone number is required'
            : `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
        isValid = false;
      } else {
        const error = validateField(key, value);
        newErrors[key] = error;
        if (error) isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleNavigateToLogin = () => {
    setSuccessDialogOpen(false);
    navigate('/login');
  };

  const handleRegister = async () => {
    if (!agreed) {
      setErrors((prev) => ({ ...prev, agreed: 'Please agree to the Terms and Conditions.' }));
      return;
    }

    if (!validateOnSubmit()) return;

    setLoading(true);
    const payload = {
      full_name: formData.fullName,
      email_id: formData.email,
      contact_number: formData.contactNumber,
      terms_conditions: agreed,
    };

    try {
      const response = await fetch('https://propertydealstalk.com/api/users/userRegistration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.status === "SUCCESS") {
        setSuccessDialogOpen(true);
      } else {
        setErrors((prev) => ({ ...prev, submit: data.message || 'Registration failed. Please try again.' }));
      }
    } catch (error) {
      console.error('Error:', error);
      setErrors((prev) => ({ ...prev, submit: 'Something went wrong. Please try again later.' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      sx={{
        width: '100%',
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      {/* Success Dialog */}
      <Dialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        PaperProps={{
          style: {
            borderRadius: '8px',
          }
        }}
      >
        <DialogTitle id="success-dialog-title">
          Registration Successful
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
            Your account has been created successfully!
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button
            onClick={handleNavigateToLogin}
            color="primary"
            variant="contained"
            autoFocus
            sx={{
              bgcolor: '#0052ff',
              borderRadius: 2,
              textTransform: 'none',
            }}
          >
            CLICK TO LOGIN
          </Button>
        </DialogActions>
      </Dialog>

      {/* Custom Loader */}
      {loading && <Loader />}

      {/* Left Image */}
      <Box
        width={isMobile ? '100%' : '40%'}
        height={isMobile ? '30vh' : '100%'}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: '#AA16FF1A',
          padding: 4,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >

         


         <img
            src={home}
            alt="Home"
            style={{
              width: isMobile ? '80px' : '100px',
              height: 'auto',
              objectFit: 'contain'
            }}
          />

          <img
            src={propmenu}
            alt="PropertyDealsTalk.com"
            style={{
              width: isMobile ? '280px' : '400px',
              height: 'auto',
              objectFit: 'contain'
            }}
          />
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          width: { xs: '100%', md: '60%' },
          height: { xs: 'calc(100vh - 30vh)', md: '100%' },
          overflowY: { xs: 'auto', md: 'hidden' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff',
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 3 },
          boxSizing: 'border-box',
        }}
      >
        {/* Form Box with Typography inside border */}
        <Box
          sx={{
            width: '100%',
            maxWidth: 320,
            borderRadius: 3,
            p: { xs: 2, sm: 3 },
            boxShadow: '0 0 20px rgba(0,0,0,0.05)',
            border: '1px solid #eee',
            mb: 2,
            mx: 'auto',
            position: 'relative',
            mt: 4,
          }}
        >
          {/* Create your account - Positioned like login.jsx */}
          <Typography
            sx={{
              position: 'absolute',
              top: -12,
              left: '50%',
              transform: 'translateX(-50%)',
              bgcolor: '#fff',
              px: 2,
              // color: '#536686',
              fontSize: '15px',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            Create your account
          </Typography>

          <Typography fontWeight={500} fontSize={14} mb={0.5} mt={1} textAlign="center">
            Fill the required details
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter your full name*"
            margin="dense"
            value={formData.fullName}
            onChange={(e) => handleFieldChange('fullName', e.target.value)}
            error={Boolean(errors.fullName)}
            helperText={errors.fullName}
            sx={{
              mb: 0.5,
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
              '& .MuiFormHelperText-root': {
                fontSize: '11px',
                marginTop: 0
              }
            }}
            inputProps={{ style: { fontSize: 14 } }}
          />

          <TextField
            fullWidth
            placeholder="Phone Number*"
            margin="dense"
            value={formData.contactNumber}
            onChange={(e) => {
              // Only allow numeric input and limit to 10 digits
              const newValue = e.target.value.replace(/\D/g, '').slice(0, 10);
              handleFieldChange('contactNumber', newValue);
            }}
            error={Boolean(errors.contactNumber)}
            helperText={errors.contactNumber}
            sx={{
              mb: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
              '& .MuiFormHelperText-root': {
                fontSize: '11px',
                marginTop: 0
              }
            }}
            inputProps={{
              style: { fontSize: 14 },
              maxLength: 10
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={phoneIcon} alt="phone" style={{ width: 18, marginRight: 10 }} />
                  <Typography variant="body2" sx={{ fontSize: 14, color: 'text.secondary' }}>
                    +91
                  </Typography>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            placeholder="Enter your email*"
            margin="dense"
            value={formData.email}
            onChange={(e) => handleFieldChange('email', e.target.value)}
            error={Boolean(errors.email)}
            helperText={errors.email}
            sx={{
              mb: 0.5,
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
              },
              '& .MuiFormHelperText-root': {
                fontSize: '11px',
                marginTop: 0
              }
            }}
            inputProps={{ style: { fontSize: 14 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={emailIcon} alt="email" style={{ width: 18, marginRight: 10 }} />
                </InputAdornment>
              ),
            }}
          />

          {errors.submit && (
            <Typography color="error" fontSize={12} mb={1}>
              {errors.submit}
            </Typography>
          )}

          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
            }
            sx={{ mt: 0.5, mb: 0.5 }}
            label={
              <Typography sx={{ fontSize: 12 }}>
                I agree to the{' '}
                <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
                  Terms of Service
                </Typography>{' '}
                and{' '}
                <Typography component="span" sx={{ color: '#0052ff', fontWeight: 500, fontSize: 12 }}>
                  Privacy Policy
                </Typography>
              </Typography>
            }
          />

          {errors.agreed && (
            <Typography color="error" fontSize={12} mb={1}>
              {errors.agreed}
            </Typography>
          )}

          <Button
            variant="contained"
            fullWidth
            disabled={loading}
            onClick={handleRegister}
            sx={{
              bgcolor: '#0052ff',
              color: '#fff',
              py: 1.2,
              fontWeight: 500,
              borderRadius: 2,
              mt: 1,
              fontSize: 14,
              textTransform: 'none',
            }}
          >
            Create Account
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Register;